module.exports = __webpack_public_path__ + "media/images/bg_voice_mv_sp-3d769e98c7a989f6b3a8adf26475c8a8.jpg";